import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface Props {
    value: string[];
    onChange: (e: string[]) => void;
}

export const TagsComponent = ({value, onChange}: Props) => {
  return (
    <TagsInput
        value={value}
        onChange={(value) => {
            onChange(value);
        }}
        renderTag={(props) => {
            const {tag, key, disabled, onRemove, getTagDisplayValue} = props;
            return (
                <div key={key} className='bg-primary text-white p-2 rounded flex gap-2 w-fit'>
                {getTagDisplayValue(tag)}
                {!disabled &&
                    <div className='cursor-pointer' onClick={() => onRemove(key)}>
                        <FontAwesomeIcon icon={faTimes as any} />
                    </div>
                }
                </div>
            )
        }}
        renderLayout={(tagElements, inputElement) => {
            return (
                <div className='flex flex-wrap gap-2'>
                {tagElements}
                {inputElement}
                </div>
            )
            }}
        focusedClassName=''
        className={`rounded border border-gray-400 py-2 px-4`}
        inputProps={{
            className: 'w-[150px] border-0 outline-none p-[5px] text-[13px]',
            placeholder: 'Agregar un mensaje'
            }}
    />
  )
}
